import React, { useState, useEffect, useRef } from "react";
import "../style.scss";
import logo from "../img/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { getDatabase, ref, set } from "firebase/database";
import { db } from "../firebase/firebase";
import { addDoc, collection } from "firebase/firestore";
import AnnouncementBar from "./AnnouncementBar";

export default function Header({
  setShowPopup,
  setShowContactMessage,
  setPopupSource,
}) {
  const [isBarHidden, setIsBarHidden] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [headerLoaded, setHeaderLoaded] = useState(false);

  const handleVisibilityChange = (visible) => {
    setIsBarHidden(!visible);
  };

  // Header load animation
  useEffect(() => {
    // Delay setting headerLoaded to true to ensure the initial CSS is applied
    const timer = setTimeout(() => {
      setHeaderLoaded(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const openIcon = document.querySelector(".fa-bars");
    const closeIcon = document.querySelector(".close-nav");
    const mobileBG = document.querySelector(".mobile-bg");
    const mobileNav = document.querySelector(".mobile-nav");
    const navItem = document.querySelector(".nav-item");
    const navItem2 = document.querySelector(".nav-item2");
    // const navItem3 = document.querySelector(".nav-item3");
    const navItem4 = document.querySelector(".nav-item4");

    openIcon.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      openIcon.classList.toggle("display-none");
    });

    closeIcon.addEventListener("click", () => {
      setTimeout(() => {
        mobileBG.classList.toggle("display-none");
        openIcon.classList.toggle("display-none");
      }, 500);
      mobileNav.classList.toggle("slide-in");
      mobileNav.classList.toggle("slide-out");
    });

    navItem.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      openIcon.classList.toggle("display-none");
    });

    navItem2.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      openIcon.classList.toggle("display-none");
    });

    // navItem3.addEventListener("click", () => {
    //   mobileBG.classList.toggle("display-none");
    //   mobileNav.classList.remove("slide-out");
    //   mobileNav.classList.toggle("slide-in");
    //   openIcon.classList.toggle("display-none");
    // });

    navItem4.addEventListener("click", () => {
      mobileBG.classList.toggle("display-none");
      mobileNav.classList.remove("slide-out");
      mobileNav.classList.toggle("slide-in");
      openIcon.classList.toggle("display-none");
    });

    // Form handling is now done in the Home component using React state and handlers

    // Close modal functionality
    const close = document.querySelector(".modal-close");
    const modal = document.querySelector(".modal-wrap");
    if (close && modal) {
      close.addEventListener("click", () => {
        modal.classList.toggle("display-none");
      });
    }

    // Login modal functionality
    const login = document.querySelector(".btn-login");
    const login2 = document.querySelector(".btn-login2");
    const loginModal = document.querySelector(".login-modal-wrap");

    if (login && loginModal) {
      login.addEventListener("click", () => {
        loginModal.classList.toggle("display-none");
      });
    }

    if (login2 && loginModal) {
      login2.addEventListener("click", () => {
        loginModal.classList.toggle("display-none");
      });
    }
  }, []);

  return (
    <>
      {/* Mobile menu - moved outside header so it's not affected by header animations */}
      <div className="mobile-bg display-none">
        <ul className="mobile-nav">
          <li>
            <a href="#hero" className="nav-item">
              Home
            </a>
          </li>
          {/* <li>
            <a href="#statistics" className="nav-item3">
              Statistiken
            </a>
          </li> */}
          <li>
            <a href="#support" className="nav-item4">
              Anfragen & Support
            </a>
          </li>
          <li>
            <a href="impressum">Datenschutz</a>
          </li>
          <li>
            <a href="#" className="nav-item2 btn-login">
              Anmelden
            </a>
          </li>
        </ul>
        <div
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
          }}
          className="close-nav"
        ></div>
      </div>

      <AnnouncementBar
        onCtaClick={() => {
          // Set popup source to 'discover' for "Jetzt entdecken" button
          setPopupSource?.("discover");
          setShowPopup?.(true);
          setShowContactMessage?.(false);
        }}
        onVisibilityChange={handleVisibilityChange}
      />
      <header
        className={`${isBarHidden ? "bar-hidden" : ""} ${
          isScrolled ? "scrolled" : ""
        } ${headerLoaded ? "header-loaded" : ""}`}
        style={{
          transform: headerLoaded ? "translateY(0)" : "translateY(-100%)",
          transition: "transform 1.2s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <nav className="container">
          <a href="" className="logo-link">
            <img src={logo} alt="" className="logo-img" />
          </a>
          <i className="menu-icon fas fa-bars">
            <FontAwesomeIcon
              className="menu-fa-icon"
              icon={icon({ name: "bars", style: "solid" })}
            />
          </i>
          <ul>
            <li>
              <a href="#hero" className="nav-link">
                Home
              </a>
            </li>

            {/* <li>
              <a href="#statistics" className="nav-link">
                Statistiken
              </a>
            </li> */}
            <li>
              <a href="#support" className="nav-link">
                Anfragen & Support
              </a>
            </li>
            <li>
              <a href="impressum" className="nav-link">
                Datenschutz
              </a>
            </li>
            <li>
              <a href="#" className="nav-link btn-login2">
                Anmelden
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}
